/**
 * Code to identify the type of BidDescriptor (400).
 * tag: 399
 * @readonly
 * @enum {number} (int)
 */
export enum BidDescriptorType {
  /** Sector */
  Sector = 1,
  /** Country */
  Country = 2,
  /** Index */
  Index = 3,
}
